import { RaidStageKind } from '../../types'
import type {
  BuildPreset,
  BuildPresetLibrary,
  BuildPresetStage,
  PlayerBuildPresetOwner,
  RaidStageKind as RaidStageKindType,
} from '../../types'

export interface BuildPresetNode {
  readonly id: string | number
  readonly name: string
  readonly orderIndex: number
  readonly stages: ReadonlyArray<{
    readonly stageKind: string
    readonly weaponSlugs: ReadonlyArray<string>
  }>
}

export interface BuildPresetLibraryNode {
  readonly playerPresets: ReadonlyArray<{
    readonly discordUserId: string
    readonly presets: ReadonlyArray<BuildPresetNode>
  }>
  readonly guildPresets: ReadonlyArray<BuildPresetNode>
}

export interface BuildPresetLibraryQuery {
  readonly buildPresetLibrary: BuildPresetLibraryNode
}

export interface MyBuildPresetsQuery {
  readonly myBuildPresets: ReadonlyArray<BuildPresetNode>
}

function parseStageKind(value: string): RaidStageKindType | null {
  switch (value) {
    case RaidStageKind.Forest:
      return RaidStageKind.Forest
    case RaidStageKind.MidPush:
      return RaidStageKind.MidPush
    case RaidStageKind.LateDefense:
      return RaidStageKind.LateDefense
    case RaidStageKind.Endgame:
      return RaidStageKind.Endgame
    case RaidStageKind.Custom:
      return RaidStageKind.Custom
    default:
      return null
  }
}

export function mapBuildPreset(node: BuildPresetNode): BuildPreset {
  const stages = node.stages.flatMap((stage): ReadonlyArray<BuildPresetStage> => {
    const stageKind = parseStageKind(stage.stageKind)
    return stageKind === null
      ? []
      : [{ stageKind, weaponSlugs: [...stage.weaponSlugs] }]
  })
  return {
    id: String(node.id),
    name: node.name,
    orderIndex: node.orderIndex,
    stages,
  }
}

export function mapBuildPresetLibrary(node: BuildPresetLibraryNode): BuildPresetLibrary {
  const playerPresets = node.playerPresets.map((owner): PlayerBuildPresetOwner => ({
    discordUserId: String(owner.discordUserId),
    presets: owner.presets.map(mapBuildPreset),
  }))
  return {
    playerPresets,
    guildPresets: node.guildPresets.map(mapBuildPreset),
  }
}
